import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AuthProvider } from '../../providers/auth/auth';
import { AppConfig } from "../../providers/config";
import { DoctorProvider } from '../../providers/doctor/doctor';
import { ClinicProvider } from '../../providers/clinic/clinic';
import { Observable } from 'rxjs';
import {startWith} from 'rxjs/operators/startWith';
import {map} from 'rxjs/operators/map';

@IonicPage()
@Component({
  selector: 'page-program-doctors-add',
  templateUrl: 'program-doctors-add.html',
})
export class ProgramDoctorsAddPage {

  program_id: string;
  program_name: string;
  user: any;
  provinces = AppConfig.Global.provinces;

  page_name: string;
  doctor: any;
  existing = false;
  validateclinic = false;
  clinics: any[] = [];
  filteredClinics$: Observable<any[]>;
  selectedClinic: any;

  addeditForm: FormGroup; 

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public toastCtrl: ToastController,
    private auth: AuthProvider,
    private dbProvider: DoctorProvider,
    private clinicProvider: ClinicProvider,
    private fb: FormBuilder) {

    if (this.navParams.get('doctordata')) {
      this.validateclinic = true;
    }
    
    this.createForm();

    this.auth.getCurrentUser().then(user => {
      this.user = { id: user.id, name: user.first_name + ' ' + user.last_name };
      this.program_name = user.program_name;
      this.program_id = user.program_id;

      this.clinicProvider
      .listClinics(this.program_id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .subscribe((clinics) => {
        this.clinics = clinics;
      });

      if (this.navParams.get('doctordata')) {
        this.doctor = this.navParams.get('doctordata')
        console.log('Existing Doctor: ', this.doctor);
        this.page_name = 'Edit ' + this.doctor.first_name + ' ' + this.doctor.last_name;
        this.addeditForm.patchValue(this.doctor);
        if(this.doctor.clinic)  {
          console.log('Inst ID: ', this.doctor.clinic.program_institution_id);
          this.addeditForm.controls['program_institution_id'].setValue(this.doctor.clinic.program_institution_id);
        } else {
          console.log('Vector: ', this.doctor.program_institution_id);
          this.clinicProvider.getClinicByVector(this.program_id, this.doctor.program_institution_id)
          .snapshotChanges()
          .map(actions => {
            return actions.map(a => {
              const data = a.payload.doc.data() as any;
              data.id = a.payload.doc.id;
              return data;
            });
          })
          .subscribe((clinic) => {
            if(clinic)  {
            this.doctor.clinic = clinic[0]
            console.log(this.doctor.clinic);
            }
          });
        }
        this.existing = true;
      } else {

        this.filteredClinics$ = this.addeditForm.controls['clinic'].valueChanges.pipe(
          startWith(''),
          map(clinic => typeof clinic === 'string' ? clinic : clinic.name),
          map(name => name ? this.filterClinics(name) : this.clinics.slice())
        );

        this.doctor = null;
        this.page_name = 'Add Physician';
        this.existing = false;
      }
    });
  }

  displayFn(clinic?: any): string | undefined {
    return clinic ? clinic.name : undefined;
  }

  setValue()  {
    // const clinic = this.addeditForm.controls['clinic'].value;
    // console.log('Clinic: ', clinic)
    // this.addeditForm.controls['program_institution_id'].setValue(clinic.program_institution_id);
    this.addeditForm.controls['clinic'].setValue('');
  }

  filterClinics(name: string) {
    return this.clinics.filter(clinic => clinic.name.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  createForm()  {
    let emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    let phoneregex: RegExp = /^\+[1-9]\d{1,14}(\se?x?t?(\d*))?$/
    let cellfaxregex: RegExp = /^\+[1-9]\d{1,14}$/

    this.addeditForm = this.fb.group({
      'clinic': [null, !this.validateclinic ? [Validators.required] : null],
      'last_name': [null, [Validators.required]],
      'first_name': [null, [Validators.required]],
      'license_number': [null, [Validators.required]],
      'specialty': [null],
      'program_institution_id': [null],
      'program_physician_id': [null],
      'fax_number': [null, [Validators.pattern(cellfaxregex)]],
      'phone_number': [null, [Validators.pattern(phoneregex)]],
      'cell_number': [null, [Validators.pattern(cellfaxregex)]],
      'email': [null, [Validators.pattern(emailregex)]],
      'address': [null],
      'address2': [null],
      'city': [null],
      'province': [null],
      'postal_code': [null],
      'admin_contact_name': [null],
      'admin_contact_phone_number': [null, [Validators.pattern(phoneregex)]],
      'admin_contact_cell_number': [null, [Validators.pattern(cellfaxregex)]],
      'admin_contact_email': [null, [Validators.pattern(emailregex)]],
      'nurse_contact_name': [null],
      'nurse_contact_phone_number': [null, [Validators.pattern(phoneregex)]],
      'nurse_contact_cell_number': [null, [Validators.pattern(cellfaxregex)]],
      'nurse_contact_email': [null, [Validators.pattern(emailregex)]],
    });
  }

  save() {
    let doctor = this.addeditForm.value;
    console.log(doctor);
    if (this.existing) {
      console.log('Doctor Associated Clinic: ', this.doctor.clinic);
      doctor.program_institution_id = this.doctor.clinic.program_institution_id;
      doctor.clinic = this.doctor.clinic;
      doctor = { clinic_id: this.doctor.clinic.id, clinic_name: this.doctor.clinic.name, ...doctor };
      console.log('Doctor Before Edit Save: ', doctor)
      this.dbProvider.updateDoctor(this.program_id, this.doctor.id, doctor, this.user)
      .then(() => {
        this.navCtrl.pop();
      })
      .catch(err => {
        this.presentToast(err.message);
      })
    } else {
      doctor.program_institution_id = doctor.clinic.program_institution_id;
      doctor = { clinic_id: doctor.clinic.id, clinic_name: doctor.clinic.name, ...doctor };
      console.log('Doctor Before Add Save: ', doctor)
      this.dbProvider.addDoctor(this.program_id, doctor, this.user)
      .then(() => {
        this.navCtrl.pop();
      })
      .catch(err => {
        this.presentToast(err.message);
      })
    }
  }

  getProgramInstitutionId(event)  {
    const clinic = event.source.value;
    this.addeditForm.controls['program_institution_id'].setValue(clinic.program_institution_id);
  }

  presentToast(message: string) {
    const toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/program-doctors-add/program-doctors-add.ts